var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-end",attrs:{"no-body":""}},[_c('div',{},[_c('b-pagination',{staticClass:"pagination-end",attrs:{"pills:total-rows":"rows","size":"lg"},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }